import React from 'react'
import { GatsbyBrowser } from 'gatsby'
import './src/styles/tailwind.css'
import { SessionContextProvider } from '@supabase/auth-helpers-react'
import { supabase } from 'clients/supabase'

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({ element }) => {
	return <SessionContextProvider supabaseClient={supabase}>{element}</SessionContextProvider>
}
